import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const MacroRendererPageLoader: LoadableType<{
	contentId: string;
	ContentExtensionsProvider?: React.ComponentType<any>;
}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-MacroRendererPage" */ './MacroRendererPage.tsx'))
			.MacroRendererPage,
});
